var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: np_r;\n  src: url(" + escape(require("./np_r.ttf")) + ");\n  font-weight: normal;\n  font-style: normal;\n}\n", "", {"version":3,"sources":["D:/OITWebSite-master/OITWebSite-master/src/assets/font/D:/OITWebSite-master/OITWebSite-master/src/assets/font/font.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mCAAqB;EACrB,oBAAoB;EACpB,mBAAmB;CACpB","file":"font.css","sourcesContent":["@font-face {\n  font-family: np_r;\n  src: url('np_r.ttf');\n  font-weight: normal;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./src/assets/font/font.css
// module id = 4MNn
// module chunks = 14